module.exports = "/_next/static/images/advance-app-preview-28ed6a8e274408838f556ae26c3eea72.svg";